import { Component, input, OnInit } from '@angular/core';
import { ReactiveFormsModule, UntypedFormControl } from '@angular/forms';
import { Password } from 'primeng/password';

@Component({
  selector: 'app-password-input',
  templateUrl: './password-input.component.html',
  styleUrls: ['./password-input.component.scss'],
  standalone: true,
  imports: [
    Password,
    ReactiveFormsModule,
  ]
})
export class PasswordInputComponent implements OnInit {
  /**
   * The control for the password input.
   */
  control = input<UntypedFormControl>(new UntypedFormControl());

  /**
   * The text to show in the form field.
   */
  label = input('');

  /**
   * The text to show in the form field when no value has been entered.
   */
  placeholder = input('******');

  /**
   * The text to show below the form field.
   */
  hint = input<string>();

  /**
   * Function to run whenever a key is pressed. Defaults to nothing.
   */
  keyupHandler = input<Function>(() => { });

  constructor() { }

  ngOnInit(): void { }

  get hasHint(): boolean {
    return this.hint() != null && this.hint() != '';
  }
}
